//@ts-nocheck
import React, { memo, createContext, useContext } from 'react'
import { Registry } from '@react-registry'
import { TriggerButton } from './Button/TriggerButton'
import { Buttons } from './toolbarComponents'
import styles from './style.module.css'
import { useRteFullScreen } from '../../../../../utils/hooks/useRteFullScreen'
import { useSlateStatic } from 'slate-react'

const toolbarContext = createContext({})
export const useToolbarProps = () => useContext(toolbarContext)

const types = ['v2.leaf', 'v2.element', 'v2.editorButtons']

const Toolbar = memo(
  (props: any) => {
    const {
      toolbarType = 'mainToolbar',
      contentStack = false,
      toolbarMode = 'advance',
      customToolbarComponents = {},
      fieldName,
      editorRef,
      pluginslen,
      closeHoveringToolbar = () => { },
      FullScreenToggle
    } = props
    const isFullScreen = useRteFullScreen(editorRef)
    const editor = useSlateStatic()

    const contextValue = { toolbarType, contentStack, toolbarMode, customToolbarComponents, editorRef, editor }

    return (
      <div className="toolbar-parent">
        {toolbarType !== 'hoveringToolbar' && <div className={'rte-field-name'}>{fieldName}</div>}
        <div className={styles['toolbar-child-inline']}>
          <toolbarContext.Provider
            value={contextValue}>
            {types.map((type) => (
              <Buttons pluginslen={pluginslen} type={type} key={type} closeHoveringToolbar={closeHoveringToolbar} />
            ))}
          </toolbarContext.Provider>
        </div>
        {isFullScreen ? (
          <div className={styles['full-screen-toggle']} >{FullScreenToggle}</div>
        ) : null}
      </div>
    )
  },
  (prev, next) => (prev.pluginslen === next.pluginslen) && (prev?.customToolbarComponents?.['v2.leaf']?.length === next?.customToolbarComponents?.["v2.leaf"]?.length) && (prev.FullScreenToggle === next.FullScreenToggle)
)

export default Toolbar
